<div class="tn-content corporate-material full-height overflow-hidden">
  <div class="tn-content-left current-focus-content full-height" *ngIf="!isDialog || (isDialog)">
    <tn-webdav-material-list [isDialog]="isDialog">
    </tn-webdav-material-list>
    <ng-container *ngIf="!isDialog">
      <tn-empty-page></tn-empty-page>
    </ng-container>
  </div>
</div>